<template lang="pug">
    span.id(v-html="time")
</template>
<script>
    module.exports = {
        props: {
            endtime: {type: Number},
            сountdown: {
                type: Boolean,
                default: true
            },
            run: {
                type: Boolean,
                default: true
            },
            hoursTime: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                state: "started",
                startTime: Date.now(),
                currentTime: Date.now(),
                interval: null
            }
        },
        mounted(){
            // if (this.run) {
            //     this.interval = setInterval(this.updateCurrentTime, 1000);
            // }
            if (this.seconds > 5) {
                this.interval = setInterval(this.updateCurrentTime, 1000);
            }
        },
        destroyed() {
            clearInterval(this.interval)
        },
        computed: {
            time() {
                if (this.hoursTime) {
                    return this.minutes + ':' + this.seconds;
                }
                else {
                    return this.hours + ':' + this.minutes + ':' + this.seconds;
                }

            },
            milliseconds() {
                if (this.endtime > 0) {
                    return (this.$data.startTime + this.endtime*1000) - this.currentTime
                }
                else {
                    return this.currentTime - this.$data.startTime;
                }

            },
            hours() {
                let lapsed = this.milliseconds;
                let hrs = Math.floor((lapsed / 1000 / 60 / 60));
                return hrs >= 10 ? hrs : '0' + hrs;
            },
            minutes() {
                let lapsed = this.milliseconds;
                let min = Math.floor((lapsed / 1000 / 60) % 60);
                return min >= 10 ? min : '0' + min;
            },
            seconds() {
                let lapsed = this.milliseconds;
                let sec = Math.ceil((lapsed / 1000) % 60);
                if (this.milliseconds > 1000) {
                    return sec >= 10 ? sec : '0' + sec;
                }
                else {
                    return sec = '00'
                }

            },
        },
        methods: {
            reset() {
                this.$data.state = "started";
                this.$data.startTime = Date.now();
                this.$data.currentTime = Date.now();
            },
            pause() {
                this.$data.state = "paused";
            },
            resume() {
                this.$data.state = "started";
            },
            updateCurrentTime() {
                this.$emit('time', this.time, this.milliseconds);
                console.log(this.milliseconds);
                if (this.$data.state === "started" && this.seconds > 1) {
                    this.currentTime = Date.now();

                }
            },
            timerStop() {
                if (this.timerStop)  {
                    this.$emit('timeStop', this.milliseconds);
                }
            }
        },
        watch: {

        }
    }
</script>